import { useQuery, type UseQueryOptions } from 'react-query';

import { metadata } from '../graphql/abt.2';
import type { Metadata_metadata, MetadataVariables } from '../graphql/abt_types.2';

export function useMetadataQuery(
  variables: MetadataVariables,
  options?: UseQueryOptions<Metadata_metadata, unknown, Metadata_metadata, ['metadata', string | null | undefined]>,
) {
  const { uuid } = variables;
  return useQuery({
    queryKey: ['metadata', uuid],
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    queryFn: async () => {
      const convertedUuid = uuid?.split('.')[0];
      const { data } = await metadata({ uuid: convertedUuid });
      return data.metadata;
    },
    ...options,
  });
}
